import { Grid, Typography, type Theme } from '@mui/material'
import { t } from 'i18next'
import { InfoYellow } from '@dhl/icons'
import type { SelectableCardData } from '~/widgets'
import type { LabelType } from '~/model'

type Props = {
  value: 'PrintedLabel' | 'QrCode'
  items: ItemType[]
}

type ItemType = SelectableCardData<LabelType>

export const LabelTypeDetailInfo = ({ value, items }: Props) => {
  const detailInfoSx = ({ typography: { fontSize } }: Theme) => ({
    fontSize,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  })
  const detailIconSx = () => ({ marginRight: 1 })
  /* eslint-disable no-nested-ternary */
  return (
    <Grid container direction="row" spacing={2} size={{ xs: 12 }}>
      {value === 'QrCode' && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography sx={detailInfoSx} data-test="label-type-detail-info-QrCode">
            <>
              <InfoYellow sx={detailIconSx} />
              {t('qrCodeDetailInfo')}
            </>
          </Typography>
        </Grid>
      )}
      {value === 'PrintedLabel' && items.length === 1 ? (
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography sx={detailInfoSx} data-test="label-type-detail-info-PrintedLabel">
            <>
              <InfoYellow sx={detailIconSx} />
              {t('printLabelDetailInfo')}
            </>
          </Typography>
        </Grid>
      ) : value === 'PrintedLabel' ? (
        <>
          <Grid size={{ xs: 12, sm: 6 }} />
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography sx={detailInfoSx} data-test="label-type-detail-info-PrintedLabel">
              <>
                <InfoYellow sx={detailIconSx} />
                {t('printLabelDetailInfo')}
              </>
            </Typography>
          </Grid>
        </>
      ) : null}
    </Grid>
  )
  /* eslint-enable no-nested-ternary */
}
